let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let Modal = require("ES/widgets/Modal");
let radio = require("ES/lib/react-pubsub-via-radio.js/radio");
let esUtils = require("ES/utils/esUtils");
let FormMixin = require("react-loose-forms");
let FormUtils = require("../../../../../utils/FormUtils");
let ErrorAlert = require("ES/widgets/ErrorAlert");
let LoadingWrap = require("ES/widgets/LoadingWrap");
let FormButtons = require("react-loose-forms.bootstrap3/layouts/FormButtons");
let RadioServiceMixin = require("ES/lib/react-pubsub-via-radio.js/RadioServiceMixin");
let ezHorizontalFields = require("react-loose-forms.bootstrap3/layouts/ezHorizontalFields");
let HorizontalFieldSpot = require("react-loose-forms.bootstrap3/layouts/HorizontalFieldSpot");
let getSpeakersFromDisplaylists = require("../../../../../utils/getSpeakersFromDisplaylists");
let AuthedUserSession = require("../../../../../utils/AuthedUserSession");

let DaForm = dd.createClass({
	mixins: [FormMixin],
	getInitialValues({event}){
		let default_sid = esUtils.toInt(_.first(event && event.sids));
		return {
			speaker: default_sid > 0 ? default_sid : undefined
		};
	},
	buildSchema(){
		let {event, Displaylists} = this.props;
		return {
			speaker: {
				type: "select",
				options: _.object(_.map(getSpeakersFromDisplaylists(Displaylists, event.sids), function(speaker){
					return [speaker.sid, speaker.name_full];
				})),
				validate(v){
					let sid = esUtils.toInt(v);
					return sid > 0 ? true : "Please select a speaker";
				}
			},
			feeitem_fee: {
				type: "select",
				label: "fee",
				options: _.mapValues(this.__getSpeakerFees(), "description"),
				validate: FormUtils.v.optional
			},
			feeitem_description: {
				type: "text",
				label: "description",
				validate: FormUtils.v.optional
			},
			feeitem_amount: {
				type: "text",
				label: "amount",
				validate: FormUtils.v.blankOr(FormUtils.v.currency)
			},
			add_replace_royalties: {
				type: "checkbox",
				label: "add/replace royalties (if any)",
			},
			expenses_code: {
				type: "text",
				label: "group code",
				validate: FormUtils.v.optional
			},
			expenses_amount: {
				type: "text",
				label: "amount",
				validate: FormUtils.v.blankOr(FormUtils.v.currency)
			}
		};
	},
	onFormChanged(field_name, new_value){
		if(field_name === "feeitem_fee"){
			let fees = this.__getSpeakerFees();
			let fee_id = esUtils.toInt(new_value);
			if(_.has(fees, fee_id)){
				this.Form_onChange("feeitem_description", fees[fee_id].description);
				this.Form_onChange("feeitem_amount", fees[fee_id].amount);
			}else if(fee_id === 0){
				this.Form_onChange("feeitem_description", "");
				this.Form_onChange("feeitem_amount", "");
			}
		}else if(field_name === "speaker"){
			this.Form_onChange("feeitem_fee", 0);
			this.Form_onChange("feeitem_description", "");
			this.Form_onChange("feeitem_amount", "");
		}
	},
	__getSpeakerFees(){
		let {data} = this.state;
		let {Displaylists} = this.props;
		let selected_speaker = _.find(Displaylists && Displaylists.perspeaker, function(spkr){
			return spkr.sid == data.speaker;
		}) || {};
		return _.object(_.map(_.filter(selected_speaker.speaker_fee_dropdown, function(f) {
			return _.get(f, ["company_id"]) === _.get(AuthedUserSession, ["activeCompany", "COMPANY_ID"]);
		}), function(o){
			return [o.id, o];
		}));
	},
	render(){
		let {onClose} = this.props;

		let sectionHead = _.bind(function(title, desc, layout){
			return dd.div(null,
				dd.h2({style: {marginBottom: ".25em"}}, title),
				dd.p({className: "help-block", style: {marginBottom: "1em"}}, desc),
				ezHorizontalFields(this, layout)
			);
		}, this);

		return dd.form({className: "form-horizontal", onSubmit: this.Form_onSubmit},
			ezHorizontalFields(this, [["speaker"]]),
			sectionHead(
				"Fee Item",
				"Select one of the speaker's fee items to add as a service with group code \"ASC\"",
				[["feeitem_fee"], ["feeitem_description"], ["feeitem_amount"]]
			),
			sectionHead(
				"Royalties",
				"Add/update the royalties based on event's company, delivery method, and product.",
				[["add_replace_royalties"]]
			),
			sectionHead(
				"Expenses",
				"Add a new service item for the speaker's expenses.",
				[["expenses_code"], ["expenses_amount"]]
			),
			dd.br(),
			dd.br(),
			HorizontalFieldSpot(null,
				FormButtons({right_align: true, onCancel: onClose, submit_btn_text: "Compute"})
			)
		);
	}
});

module.exports = dd.createClass({
	mixins: [RadioServiceMixin],
	RadioService_setup(){
		return {
			EventServices_computeFamilyValues: {
				key: "callService",
				on: {
					succeeded(){
						radio("reload_Event").broadcast(this.props.event.eid);
						this.props.onClose();
					}
				}
			}
		};
	},
	__onSubmit(data){
		this.RadioService_callService("EventServices_computeFamilyValues", _.assign({
			eid: this.props.event.eid
		}, data));
	},
	render(){
		let {event, Displaylists, onClose} = this.props;
		let ajax = this.state.EventServices_computeFamilyValues;
		if(ajax.waiting){
			return Modal({
					title: "Computing...",
					buttons: []
				},
				LoadingWrap({is_loading: true, text: "Computing..."})
			);
		}
		if(ajax.error){
			return Modal({
					title: "Error",
					onClose
				},
				ErrorAlert({message: ajax.error})
			);
		}

		return Modal({
				title: "Compute",
				onClose,
				buttons: []
			},
			DaForm({event, Displaylists, onClose, onSubmit: this.__onSubmit})
		);
	}
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/services/ComputeBtnModal.js